// src/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-copyright">
                    <p>Developer ❤️ Aniket Saini</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
